<div *ngIf="model && model.totalCount > 0" class="pagination row align-items-center">
  <div class="info page-size col-2" [ngClass]="{ 'col-lg-1': !isMapSideNav }">
    <span class="label">Page Size:</span>
    <mat-select [(value)]="model.pageSize" (selectionChange)="setPageSize(model.pageSize)">
      <mat-option *ngFor="let x of model.pageSizeOptions" [value]="x"> {{ x }} </mat-option>
    </mat-select>
  </div>

  <div class="page-functions col-8" [ngClass]="{ 'col-lg-10': !isMapSideNav }">
    <ul
      *ngIf="model.totalCount > model.pageSize"
      class="pages list-unstyled list-inline"
      [hidden]="!pages || pages.length < 2"
    >
      <li *ngIf="showFirstLastActions">
        <button mat-icon-button [disabled]="model.pageNumber === 1" (click)="setPage(1)">
          <mat-icon>first_page</mat-icon>
        </button>
      </li>
      <li *ngIf="showPreviousNextActions">
        <button
          mat-icon-button
          [disabled]="model.pageNumber === 1"
          (click)="setPage(model.pageNumber - 1)"
        >
          <mat-icon>navigate_before</mat-icon>
        </button>
      </li>

      <!-- main pagination -->
      <li *ngFor="let pg of pages" class="d-none d-sm-inline">
        <button mat-icon-button (click)="setPage(pg)" [class.active]="pg === model.pageNumber">
          {{ pg }}
        </button>
      </li>
      <!-- /main pagination -->

      <li *ngIf="showPreviousNextActions">
        <button
          mat-icon-button
          [disabled]="model.pageNumber === totalPages"
          (click)="setPage(model.pageNumber + 1)"
        >
          <mat-icon>navigate_next</mat-icon>
        </button>
      </li>
      <li *ngIf="showFirstLastActions">
        <button
          mat-icon-button
          [disabled]="model.pageNumber === totalPages"
          (click)="setPage(totalPages)"
        >
          <mat-icon>last_page</mat-icon>
        </button>
      </li>
    </ul>
  </div>

  <div class="info page-nav-status col-2" [ngClass]="{ 'col-lg-1': !isMapSideNav }">
    <span class="startIndex">{{ model.pageSize * (model.pageNumber - 1) + 1 }} -</span>
    <span class="endIndex">
      {{
        model.pageSize * model.pageNumber > model.totalCount
          ? model.totalCount
          : model.pageSize * model.pageNumber
      }}
    </span>
    <span class="total">of {{ model.totalCount }}</span>
  </div>
</div>
